export default __webpack_public_path__ + "static/media/r5.22c2cb52.png";